"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carrosel = void 0;
var react_1 = __importDefault(require("react"));
var react_slick_1 = __importDefault(require("react-slick"));
require("slick-carousel/slick/slick-theme.css");
require("slick-carousel/slick/slick.css");
var carrosel_styles_1 = require("./carrosel.styles");
var sliderSettingsMobile = {
    dots: true,
    dotsClass: 'slick-dots',
    infinite: false,
    arrows: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            },
        },
        {
            breakpoint: 1007,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 690,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};
var Carrosel = function (_a) {
    var dispositivo = _a.dispositivo, children = _a.children;
    var settings = function () {
        if (dispositivo === 'mobile')
            return __assign({}, sliderSettingsMobile);
        return {};
    };
    return (react_1.default.createElement(carrosel_styles_1.SliderStyled, null,
        react_1.default.createElement(react_slick_1.default, __assign({}, settings()), children)));
};
exports.Carrosel = Carrosel;
